const RouteErrorsMaintenance = () => 'Maintenance'

export default RouteErrorsMaintenance



// WEBPACK FOOTER //
// ./src/routes/errors/maintenance.js